export enum MonthsToAccessFundingType {
    SixMonth = 0,
    NineMonths = 1,
    TwelveMonths = 2,
}

export const MonthsToAccessFundingTypeOptions = [
    {
        id: MonthsToAccessFundingType.SixMonth,
        name: '6 Months',
    },
    {
        id: MonthsToAccessFundingType.NineMonths,
        name: '9 Months',
    },
    {
        id: MonthsToAccessFundingType.TwelveMonths,
        name: '12 Months',
    },
];
